// extracted by mini-css-extract-plugin
export default {"container":"Employees_container__MyEnU","contentWrapper":"Employees_contentWrapper__8TPfM"};